module.exports = __webpack_public_path__ + "image-318aedf4e4ad.png";